import React from 'react'
import { styled } from '@mui/material/styles'
import T from 'prop-types'
import { Box, Stack, Typography } from '@mui/material'

export default function DotCell({
  color = 'textPrimary',
  label,
  labelProps,
  ...others
}) {
  const Dot = styled('span')(({ color, theme }) => ({
    width: theme.spacing(1),
    height: theme.spacing(1),
    borderRadius: '100%',
    backgroundColor:
      color === 'textPrimary' || color === 'textSecondary'
        ? theme.palette.text[color.substring(4).toLowerCase()]
        : theme.palette[color].main,
    marginRight: theme.spacing(1),
    flexShrink: 0,
  }))

  return (
    <Stack direction="row" alignItems="center" {...others}>
      <Dot color={color} />
      <Typography
        variant="body2"
        color={
          color === 'warning'
            ? 'warning.main'
            : color === 'success'
            ? 'success.main'
            : color
        }
        component={typeof label !== 'string' ? Box : undefined}
        {...labelProps}
      >
        {label}
      </Typography>
    </Stack>
  )
}

DotCell.propTypes = {
  color: T.oneOf([
    'primary',
    'secondary',
    'warning',
    'error',
    'textPrimary',
    'textSecondary',
  ]),
  label: T.oneOfType([T.string, T.node]),
  labelProps: T.object,
  others: T.object,
}
